import LyDropdown from './src/index.vue'

LyDropdown.install = function (Vue) {
    Vue.component(LyDropdown.name, LyDropdown)
}

export default LyDropdown



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/dropdown/index.js
// module id = null
// module chunks = 